import { Navigate } from 'react-router'

/**
 * Signup is now handled by the combined LoginPage component.
 * Redirect /signup to /login?mode=signup for backwards compatibility.
 */
export function SignupPage(): React.JSX.Element {
  return <Navigate to="/login?mode=signup" replace />
}
